import { createFileRoute } from "@tanstack/react-router";
import BlogPost from "@/pages/BlogPost";
import { pageHead } from "@/lib/seo-head";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/blog/$slug")({
  component: BlogPostRoute,
  loader: async ({ params }) => {
    const { data } = await supabase
      .from("blog_posts")
      .select("*")
      .eq("slug", params.slug)
      .maybeSingle();
    return {
      post: data ? { ...data, tags: data.tags ?? [], published_at: data.published_at ?? "" } : null,
    };
  },
  head: ({ params, loaderData }) => {
    const post = loaderData?.post;
    if (!post) {
      return pageHead({
        title: "Post Not Found | jaik",
        description: "This blog post is not available.",
        path: `/blog/${params.slug}`,
        noindex: true,
      });
    }

    const title = post.meta_title || post.title;
    const description =
      post.meta_description ||
      post.excerpt ||
      "Contractor SEO and website advice for King County and Puget Sound trades.";

    return pageHead({
      title,
      description,
      path: `/blog/${params.slug}`,
      ogType: "article",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: post.title,
        description,
        datePublished: post.published_at || undefined,
        author: { "@type": "Person", name: post.author || "jaik" },
        publisher: { "@type": "Organization", name: "jaik" },
        mainEntityOfPage: `https://jaikmarketing.com/blog/${params.slug}`,
      },
    });
  },
});

function BlogPostRoute() {
  const { post } = Route.useLoaderData();
  return <BlogPost initialPost={post} />;
}
